export default __webpack_public_path__ + "static/daniel-sf-51c5a3c7bec8999ab5ad6170369c2540.png";